export default "__VITE_ASSET__B4lm5w6U__"